import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import {
  FDDisplayText, FDHeadlineText, FDTitleText,
} from '@facet-wealth/design';
import { withValueArray } from 'Helpers/MetaOverride';
import StripeInput from 'Components/ComponentLibrary/Organisms/StripeInput/StripeInput';
import { Total } from './Total';
import ModuleName from './ModuleName';
import { LineItems } from './LineItems';


export const overrides = buildFacetDesignOverride()
  .nameOverride('moduleName', {
    _component: () => ModuleName,
  }, overrideReadOnly)
  .nameOverride('emailVerificationStepTitle', {
    _component: () => FDDisplayText,
    _customProps: { size: 'md', align: 'center' },
  }, overrideReadOnly)
  .nameOverride(['agreementTitle', 'paymentTitle'], {
    _component: () => FDHeadlineText,
    _customProps: { size: 'sm' },
  }, overrideReadOnly)
  .nameOverride('subtitle', {
    _component: () => withValueArray(FDHeadlineText),
    _customProps: { align: 'center', size: 'lg' },
  }, overrideReadOnly)
  .nameOverride('subscriptHeader', {
    _component: () => FDTitleText,
    _customProps: { size: 'lg' },
  }, overrideReadOnly)
  .nameOverride('lineItems', {
    _component: () => LineItems,
  }, overrideReadOnly)
  .nameOverride('stripeToken', {
    _component: () => StripeInput,
  }, overrideReadOnly)
  .nameOverride('dueNow', {
    _component: () => Total,
  }, overrideReadOnly)
  .done();
